import React from 'react'
import axios from 'axios'
import {getHost} from '../../utils/request'

class SignOut extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: 'Signing out ...',
        };
    }

    async componentDidMount() {
        const axiosConfig = {withCredentials: true};
        let isPartnerLogin = false;

        try {
            const settingsRes = await axios.get(getHost() + "/auth/settings/get", axiosConfig);
            isPartnerLogin = settingsRes && settingsRes.data && settingsRes.data.isPartnerLogin;
        } catch (e) {
            // Continue with sign out even if settings fetch fails
        }

        try {
            await axios.post(getHost() + "/signOut", {}, axiosConfig);
        } catch (e) {
            this.setState({message: "Error signing out: " + e.message});
            return;
        }

        let closeTabString = "";
        if (isPartnerLogin) {
            closeTabString = "?closeTab=1";
        }

        this.props.history.push('/signIn' + closeTabString);
    }

    render() {
        return <div>
            <h1>{this.state.message}</h1>
        </div>;
    }
}

export default SignOut